import React from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { AppState } from 'stores/type';
import { LanguageDomain } from 'models/Language';
import { IntlProvider } from 'react-intl';
import { locales } from 'locals';

export const SetLocale: React.FC = ({ children }) => {
  const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
  const device = useSelector((state) => state.deviceState.device);
  // Deviceから取れたユーザーのlocale情報を使って表示言語を決定する
  // エラーが出た場合は Root/index.tsx で指定しているブラウザ言語でエラーページが表示される
  const locale = LanguageDomain.getLanguage(device?.user?.locale || '');

  return <IntlProvider {...locales[locale]}>{children}</IntlProvider>;
};
